/**
 * Deployment-environment detection for the PharmaPOS PWA.
 *
 * The demo environment is served from the SAME build as production, so the
 * label is decided at runtime — there is no separate demo build to maintain.
 * Brand + storefront domains come from /site-config.js (per deployment), which
 * keeps this working for white-label servers on their own domains.
 */
import { siteBrand } from './site-config.js';

export const IS_DEMO = location.hostname.split('.').includes('demo');

/** App name for the tab title, login screen, manifests, etc. */
export const APP_DISPLAY_NAME = IS_DEMO ? `${siteBrand()} (DEMO)` : siteBrand();
